import React, { Component } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';

import Loader from '../utils/Loadersmall';

class Deliveryinfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            serviceCheck:false,
        }   
    }

    async componentDidMount() {
       
    }

    render() {

        // if(this.state.serviceCheck===false)
        // return (<Loader/>);

        return (

            <div class="ps-about">

                <div class="ps-about__content">
                    {/* <section class="ps-about__banner" data-background="assets/img/Mask-Group.jpg">
                        <div class="container">
                            <div class="ps-banner">
                                <h2 class="ps-banner__title">About Us</h2>
                                <div class="ps-banner__desc">Completely the needs of home medicine chest and professional offices</div><a class="ps-banner__shop" href="category-list.html">Shop now</a>
                            </div>
                        </div>
                    </section> */}
                    <section class="ps-about__project">
                        <div class="container-fluid">
                            <h2 class="ps-banner__desc text-center">Shipping and Delivery Policy</h2>
                            <section >
                                {/* <div class="ps-section__thumbnail"> <a class="ps-section__image" href="#"><img src="assets/img/about/about-us-1.jpg" alt="" /></a></div> */}
                                <div class="ps-section__content">
                                        
                                        <p class="ps-section__desc">Any shipping and delivery matters are governed by this policy ("Shipping and Delivery Policy")</p>

                                        <h4>1. Delivery charges</h4>
                                        <p class="ps-section__desc">a. You will be shown the delivery charges due for each order prior to making a payment. We work with logistics providers to provide you with the best possible rates, where applicable.</p>


                                        <h4>2. Dispatch time</h4>
                                        <p class="ps-section__desc">Please allow 2-7 working days post your placement of order for the shipment to be dispatched.</p>


                                        <h4>3. Delivery time</h4>
                                        <p class="ps-section__desc">The delivery time is approximately 7 working days for domestic shipments from the date of shipment within India. Deliveries will be made to the address provided by you at the time of the order.</p>

                                        <p class="ps-section__desc">Though we endeavor to ensure that the shipment reaches you in time, there may be delays due to unforeseen circumstances.</p>

                                        <p class="ps-section__desc">For international orders, please budget for upto 15 business days from the date of shipping. </p>

                                        <h4>4. Damaged / Defective goods</h4>
                                        <p class="ps-section__desc">If the goods you receive are damaged or defective or not matching your order, you will be required to intimate us about such cases within 24 hours of delivery. Please refer to our Returns and Exchange policy for more details.</p>


                                        <h4>5. Product Returns</h4>
                                        <p class="ps-section__desc">The shipping costs incurred for the return of any item(s) will be borne you. Please refer to our Returns and Exchange policy for more details.</p>


                                        
                                        </div>
                            </section>
                        </div>
                    </section>
        
                </div>
            
            </div>
    
        );
    }
}

export default Deliveryinfo;